export const labels = {
	title: {
		label: "Label.MobileCreator.ProductWarning.Title",
		default: "Your product has some errors",
	},
	ok: {
		label: "Label.MobileCreator.ProductWarning.Proceed",
		default: "Ok",
	},
} as const;
